// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"a04381a2","496":"264293ee"}[chunkId] + ".chunk.js";
};